/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BulkConversationPassthroughCreateParams } from '../models/BulkConversationPassthroughCreateParams';
import type { BulkConversationPassthroughUpdateParams } from '../models/BulkConversationPassthroughUpdateParams';
import type { BulkOperationResponse } from '../models/BulkOperationResponse';
import type { BulkSingleConversationCreateParams } from '../models/BulkSingleConversationCreateParams';
import type { FunnelConversationCreateResponse } from '../models/FunnelConversationCreateResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V1ConversationsService {
    /**
     * Create multiple conversations in a single request.
     *
     * This endpoint allows you to create multiple conversations at once. Each conversation in the batch
     * will be validated before processing. The response includes details about any validation issues
     * encountered during processing.
     *
     * If some conversations fail validation, the valid ones will still be processed.
     * @param requestBody
     * @returns BulkOperationResponse Ok
     * @throws ApiError
     */
    public static bulkCreate(
        requestBody: BulkConversationPassthroughCreateParams,
    ): CancelablePromise<BulkOperationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/conversations/bulk',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update multiple conversations in a single request.
     *
     * This endpoint allows you to update multiple existing conversations at once. Each conversation
     * update in the batch will be validated before processing. The response includes details about
     * any validation issues encountered during processing.
     *
     * You must provide the ID for each conversation you want to update. If some conversations fail
     * validation, the valid ones will still be processed.
     * @param requestBody
     * @returns BulkOperationResponse Ok
     * @throws ApiError
     */
    public static bulkUpdate(
        requestBody: BulkConversationPassthroughUpdateParams,
    ): CancelablePromise<BulkOperationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/conversations/bulk/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create a single conversation.
     *
     * This endpoint allows you to create a single conversation and returns the created conversation
     * immediately with all associated data including contact information.
     *
     * Use this endpoint when you need the created conversation immediately for subsequent operations.
     *
     * Either `contactId` or `contact` information must be provided. If `contact` is provided,
     * a new contact will be created or an existing contact will be matched based on the addresses and updated.
     * @param requestBody
     * @returns FunnelConversationCreateResponse Ok
     * @throws ApiError
     */
    public static create(
        requestBody: BulkSingleConversationCreateParams,
    ): CancelablePromise<FunnelConversationCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/conversations',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation Error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
}
